import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>POST /spaces/invite</h1>
        </div>
        <p>
          Creates a new space and a new invitation(s). The user that calls this
          API will be an admin in the space.
        </p>
        <h2>URL Parameters</h2>
        <p>None.</p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>topic</td>
                <td>
                  Object describing the space to be created.
                  <ul>
                    <li>
                      <em>id</em>: (string) should be null.
                    </li>
                    <li>
                      <em>title</em>: (string) name of the new space.
                    </li>
                    <li>
                      <em>description</em>: (string, optional) description of
                      the new space.
                    </li>
                    <li>
                      <em>type</em>: (string) 'group'.
                    </li>
                  </ul>
                </td>
                <td>Object</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>invitees</td>
                <td>
                  Array of objects describing the members to invite.
                  <ul>
                    <li>
                      <em>inviteeType</em>: (string) 'email' (invitee is not a
                      spaces user) or 'userid' (invitee is a user)
                    </li>
                    <li>
                      <em>invitee</em>: (string) the email address (if
                      inviteeType is email) or the userid (if inviteeType is
                      user)
                    </li>
                    <li>
                      <em>role</em>: (string) permission level in space:
                      ('admin', 'member' (default), 'guest')
                    </li>
                  </ul>
                </td>
                <td>Object</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>startDateTime</td>
                <td>UTC timestamp space start time.</td>
                <td>string</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>endDateTime</td>
                <td>UTC timestamp space end time.</td>
                <td>string</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>informChannel</td>
                <td>
                  'server' (Spaces will email the invites), 'client' (Spaces
                  will return the html of the invites for the user to send),
                  'outlook' (Spaces will return special html compatible with
                  Microsoft Outlook)
                </td>
                <td>string</td>
                <td>No</td>
                <td>server</td>
              </tr>
              <tr>
                <td>inviteMode</td>
                <td>
                  'invite' (invite link to join space), 'meet' (invite to join
                  and meet in fullscreen video/audio session)
                </td>
                <td>string</td>
                <td>No</td>
                <td>join</td>
              </tr>
              <tr>
                <td>inviteContentLanguage</td>
                <td>
                  The language code in the response field "inviteContent".
                  Without this value, system uses the sender's primary language.
                  If the input language is not supported by spaces, spaces apply
                  default language code 'en-US'.
                </td>
                <td>string</td>
                <td>No</td>
                <td>server</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>PERM_TOPIC_CREATE</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/spaces/invite
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h4>Body</h4>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"topic": {"{"}
          {"\n"}
          {"    "}"id": null,{"\n"}
          {"    "}"title": "invite + new space",{"\n"}
          {"    "}"description": "",{"\n"}
          {"    "}"type": "group"{"\n"}
          {"  "}
          {"}"},{"\n"}
          {"  "}"invitees": [{"{"}
          {"\n"}
          {"    "}"inviteeType": "email",{"\n"}
          {"    "}"invitee": "han42@avaya.com",{"\n"}
          {"    "}"role": "member"{"\n"}
          {"  "}
          {"}"}],{"\n"}
          {"  "}"startDateTime": "2017-04-28T19:55:50.950Z",{"\n"}
          {"  "}"endDateTime": "2017-04-28T20:55:50.950Z",{"\n"}
          {"  "}"informChannel": "server"{"\n"}
          {"}"}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"data": [{"{"}
          {"\n"}
          {"    "}"topicId": "59039e47e2cda45e3bbbfc7f",{"\n"}
          {"    "}"startDateTime": "2017-04-28T19:55:50.950Z",{"\n"}
          {"    "}"endDateTime": "2017-04-28T20:55:50.950Z",{"\n"}
          {"    "}"_id": "59039e47e2cda45e3bbbfc80",{"\n"}
          {"    "}"invitees": [{"{"}
          {"\n"}
          {"      "}"inviteeType": "email",{"\n"}
          {"      "}"invitee": "han42@avaya.com",{"\n"}
          {"      "}"role": "member"{"\n"}
          {"    "}
          {"}"}],{"\n"}
          {"    "}"created": "2017-04-28T19:55:51.102Z"{"\n"}
          {"  "}
          {"}"}]{"\n"}
          {"}"}
        </pre>
      </div>
    </div>
  </Layout>
)
